import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';

@Component({
   selector: 'samweb-text-area',
   templateUrl: './text-area.component.html',
   styleUrls: ['./text-area.component.scss'],
})
export class TextAreaComponent implements OnInit {
   constructor() {}
   @Input()
   public icon: IconDefinition;

   @Input()
   public header: string;

   @Input()
   public value: string;

   @Input()
   public showWarning = false;

   @Input()
   public fadeIconOpacity = false;

   @Input()
   public swapIconOpacity = false;

   @Input()
   public disabled = false;

   @Input()
   public isFocused = false;

   @Input()
   public highlightIcon = false;

   @Output()
   public valueChanged = new EventEmitter();

   @Output()
   public valueChangedDebounced = new EventEmitter();

   public clearFilterIcon: IconDefinition = WellKnownIconsEnum.CLEAR.iconSmall;

   ngOnInit(): void {}

   textChanged(value: string) {
      if (!this.disabled) {
         this.valueChanged.emit(value);
      }
   }

   textChangedDebounced(value: string) {
      if (!this.disabled) {
         this.valueChangedDebounced.emit(value);
      }
   }

   clearText() {
      if (!this.disabled) {
         this.valueChanged.emit('');
         this.valueChangedDebounced.emit('');
      }
   }
}
